import api from '../base';
import { Address } from '../address/addressApiTypes';
import { mockCreateOrUpdateAddress, mockGetAddress } from './b2bMock';
import {
  B2bAddress, B2bAddressType, mapAddress, mapB2bAddress,
} from './b2bApiTypes';

const B2B_PRODUCTS_BASE_PATH = 'management/b2b-products';
const B2B_PARTNERS_BASE_PATH = 'management/b2b-partners';

export async function importB2bPrices(file: FormData): Promise<void> {
  const response = await api.post<void>(`${B2B_PRODUCTS_BASE_PATH}/import`, file, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
}

api.mock
  .onPost(/management\/b2b-products\/import/)
  .reply(200);

function getB2bAddressPath(type: B2bAddressType): string {
  return `${B2B_PARTNERS_BASE_PATH}/address/${type}`;
}

export async function getB2bAddress(
  type: B2bAddressType,
  signal?: AbortSignal,
): Promise<Address> {
  const response = await api.get<B2bAddress>(
    getB2bAddressPath(type),
    { signal },
  );

  return mapAddress(response.data);
}

export async function createOrUpdateB2bAddress(
  type: B2bAddressType,
  address: Omit<Address, 'id'>,
  signal?: AbortSignal,
): Promise<Address> {
  const response = await api.post<B2bAddress>(
    getB2bAddressPath(type),
    mapB2bAddress(address),
    { signal },
  );

  return mapAddress(response.data);
}

api.mock
  .onGet(/management\/b2b-partners\/address\/BUYER/)
  .reply(200, mockGetAddress);

api.mock
  .onPost(/management\/b2b-partners\/address\/BUYER/)
  .reply(200, mockCreateOrUpdateAddress);

api.mock
  .onGet(/management\/b2b-partners\/address\/SUPPLIER/)
  .reply(404);

api.mock
  .onPost(/management\/b2b-partners\/address\/SUPPLIER/)
  .reply(200, mockCreateOrUpdateAddress);
